import { useNavigate } from "react-router";

import { Button } from "@/components/ui/button";

interface ErrorMessageProps {
  title: string;
  message: string;
}

export const ErrorMessage = ({ title, message }: ErrorMessageProps) => {
  const navigate = useNavigate();
  return (
    <div className="flex-1 p-6 flex flex-col">
      <div className="mt-16 mx-auto">
        <div className="bg-gray-50 rounded-lg shadow-md p-8 max-w-md relative">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center">
              <span className="text-gray-600">!</span>
            </div>
            <h2 className="font-bold text-xl">{title}</h2>
          </div>
          <p className="text-gray-600 mb-6">{message}</p>
          <Button onClick={() => navigate("/")}>Go Home</Button>

          {/* Adding stacked card effect similar to SignIn component */}
          <div className="absolute bg-white rounded-lg shadow-md w-[98%] h-[98%] bottom-[-4px] left-[1%] -z-10"></div>
          <div className="absolute bg-white rounded-lg shadow-sm w-[96%] h-[96%] bottom-[-8px] left-[2%] -z-20"></div>
        </div>
      </div>
    </div>
  );
};
